import { InMemoryCache } from "@apollo/client/cache";

const cacheConfig = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        getResourcesForScheduler: {
          keyArgs: ['resourceType', 'searchBy'],
          merge(existing, incoming, { args }) {
            const existingNodes = existing?.nodes ?? [];
            return {
              ...incoming,
              nodes: args?.after ? [...existingNodes, ...incoming.nodes] : incoming.nodes,
            };
          },
        },
      },
    },
  },
})

export default cacheConfig
